/**
 * Class for handling device REST request
 * @copyright 2021-2026 Soter Technologies, LLC. All rights reserved.
 * @file devicesFeatures.js
 * @author Kyle Watkins, Paul Scala, Bryan Lai
 */

class DeviceFeatures {
    /**
     * Initialize class
     * @param {object} axios Axios instance
     * @param {object} session User session handler
     */
    constructor(axios, session) {
        this.axios = axios
        this.session = session
    }
    
    /**
     * Get device feature's feature bits
     * @returns {ResponseObject} Api response object
     */
    async getFeatureBits() {
        // Set request config
        let config = {
            method: 'get',
            url: `/api/devicefeatures/featurebits/all`,
        }

        // Get devices
        let res = await this.axios(config)
    
        return ({
            status: res.status, 
            statusText: res.statusText,
            isSuccess: (res.status >= 200 && res.status < 300),
            data: res.data
        })
    }
}

export default DeviceFeatures